export default {
    set(key, value) {       
        if(! window.localStorage){
            console.warn("浏览器不支持localstorage");
        } else {
            localStorage.setItem(key, JSON.stringify(value));
        }
    },

    get(key) {
        if(! window.localStorage){
            console.warn("浏览器不支持localstorage");
            return "";
        } else {
            const str = localStorage.getItem(key);
            const value = str ? JSON.parse(str) : "";
            return value;
        }
    },
    remove(key) {
        if(! window.localStorage){
            console.warn("浏览器不支持localstorage");
            return false;
        } else {
            if (!key) throw new Error("localStorage 删除操作必须传入对应的 key 值。");
            localStorage.removeItem(key);
            return true;
        }
    }
}